$(document).ready(function () {
  var sortWidth = $("#sort-by").width();
  var optionWidth = $("#sort-by option").filter(":selected").text();
  if (optionWidth == "Featured") {
    $("#sort-by").width("7em");
  } else if (
    optionWidth == "Price: Low to High" ||
    optionWidth == "Price: High to Low"
  ) {
    $("#sort-by").width("13em");
  } else if (optionWidth == "A-Z" || optionWidth == "Z-A") {
    $("#sort-by").width("2.5em");
  } else if (
    optionWidth == "Date, old to new" ||
    optionWidth == "Date, new to old"
  ) {
    $("#sort-by").width("12em");
  } else if (optionWidth == "Best Selling") {
    $("#sort-by").width("9em");
  }
  console.log(optionWidth);
});

$(document).ready(function () {
  $("#sort-by").bind("change", function () {
    $("#width_tmp_option").html($("#sort-by option:selected").text());
    $(this).width($("#width_tmp_select").width());``
  });
});

Shopify.queryParams = {};
if (location.search.length) {
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
    i < aCouples.length;
    i++
  ) {
    aKeyValue = aCouples[i].split("=");
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
        decodeURIComponent(aKeyValue[1]);
    }
  }
}
jQuery("#sort-by")
  .val(
    "{{ collection.sort_by | default: collection.default_sort_by | escape }}",
  )
  .bind("change", function () {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
  });
